import { render, staticRenderFns } from "./AdviserHub.vue?vue&type=template&id=6fc36cda&"
import script from "./AdviserHub.vue?vue&type=script&lang=js&"
export * from "./AdviserHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports